import { imgPrefix } from '@/utils/imgPrefix';
import Image from 'next/image';
import styles from '../FeedbackValidation.module.scss';
import { useEffect, useState } from 'react';

export default function FeedbackValidationInProgressDocument() {
  const [paragraph, setParagraph] = useState(
    'Te daremos um retorno em alguns segundos!'
  );

  useEffect(() => {
    setTimeout(() => {
      setParagraph('Parece que está demorando um pouco mais do que o normal');
    }, 10000);
  }, []);

  return (
    <div className={`${styles['wrapper-feedback']}`}>
      <p className={`${styles['main-title']}`}>
        Validação de Documento Digital
      </p>

      <div className={`${styles['feedback']}`}>
        <Image
          src={imgPrefix('/images/spinner-loading.svg')}
          alt="loading spinner image"
          width={106}
          height={106}
          quality={100}
          className={`${styles['loading-spinner']}`}
        />

        <p className={`${styles['feedback-title']}`}>
          Estamos verificando o documento...
        </p>

        <span>{paragraph}</span>
      </div>
    </div>
  );
}
